import Image from "next/image";
import { cn } from "@/lib/utils";

/**
 * 빈 화면 틀(09-29) — 그림 + 제목(상황) + 설명(다음 행동) + 버튼 자리.
 * 지점 허브 빈 화면과 일반 검색 0건 화면이 같이 쓴다.
 *
 * 좁은 칸(모바일 드로어)은 가운데 세로 정렬, 넓은 칸(태블릿·데스크톱 목록)은
 * 그림 왼쪽 · 글 오른쪽.
 */
export function EmptyStateLayout({
  image,
  title,
  body,
  wide,
  children,
}: {
  /** /public 의 320px WebP 그림 */
  image: string;
  title: React.ReactNode;
  body?: React.ReactNode;
  wide: boolean;
  /** 버튼·알약 — 정렬(가운데/왼쪽)은 wide 에 맞춰 호출자가 준다 */
  children?: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        "flex",
        wide
          ? "flex-row items-center justify-center gap-7 px-6 py-16 text-left"
          : "flex-col items-center px-7 pt-7 pb-9 text-center",
      )}
    >
      <Image
        src={image}
        alt=""
        width={wide ? 150 : 112}
        height={wide ? 150 : 112}
        className={cn("shrink-0 object-contain", wide ? "size-[150px]" : "size-28")}
        // 로컬 /public 자산 — 홈 카테고리 타일과 같이 정적 원본 서빙(이미지 최적화 과금 제외)
        unoptimized
      />
      <div className={cn("flex min-w-0 flex-col", wide ? "items-start" : "items-center")}>
        <h3
          className={cn(
            "font-bold text-balance break-keep text-gray-900",
            wide ? "mb-2 text-[22px] leading-snug" : "mt-3.5 mb-1.5 text-lg leading-snug",
          )}
        >
          {title}
        </h3>
        {body ? (
          <p
            className={cn(
              "text-sm leading-relaxed break-keep text-gray-500",
              wide ? "max-w-[300px]" : "max-w-[260px]",
            )}
          >
            {body}
          </p>
        ) : null}
        {children}
      </div>
    </div>
  );
}
